<template>
	<page-container :page="page">
		<heading-image
			v-if="page.headingImage"
			:heading-image="{
				image: page.headingImage,
				imageWebp: page.headingImageWebp,
				imagePortrait: page.headingImagePortrait,
				imagePortraitWebp: page.headingImagePortraitWebp,
			}"
		/>
		<breadcrumbs :breadcrumbs="page.breadcrumbs" :class="page.headingImage ? '' : 'no-slider'" />

		<main-content>
			<template #content>
				<div class="columns column6">
					<h1>{{ page.title || page.header }}</h1>
					<p v-if="page.bookingID">
						<!-- <book-button class="button button-no-fill" :data-roomID="page.booking - id">
							{{ $t('bookThisRoom') }}
						</book-button> -->
					</p>
				</div>
				<div class="columns column6">
					<div v-parse-links v-html="page.content" />
				</div>
			</template>
		</main-content>

		<section class="main-content room-info">
			<div class="row background-light">
				<div class="columns column12 align-center">
					<h2>{{ $t('aboutThisRoom') }}</h2>
				</div>
				<div class="columns column8">
					<h3>{{ $t('facilities') }}</h3>
					<div class="room-icons">
						<div v-for="facility in page.facilities" :key="facility.id" class="icon-holder">
							<font-awesome-icon :icon="`fal fa-${facility.icon}`" size="1x" />
							<span>{{ facility.content }}</span>
						</div>
					</div>
				</div>
				<div class="columns column4">
					<div v-parse-links v-html="page.extraContent" />
				</div>
			</div>
		</section>

		<section class="main-content gallery-section">
			<div class="gallery-grid row">
				<div v-for="(item, index) in page.images" :key="index">
					<a
						:data-src="!isVideo ? item.image : item.embedCode"
						class="gallery-item"
						:class="{ 'fancybox.iframe': isVideo }"
						data-fancybox="gallery"
						:data-caption="item.imageAlt"
						:title="item.imageAlt"
					>
						<picture>
							<source v-if="item.imagesWebp" :srcset="item.imagesWebp" type="image/webp" />
							<source :srcset="item.images" />
							<img :src="item.image" :alt="item.imageAlt" loading="lazy" />
						</picture>
					</a>
				</div>
			</div>
			<div class="row align-center">
				<div class="columns column12">
					<span v-if="page.bookingID">
						<book-button class="button button-cta" :data-roomID="page.booking - id">
							{{ $t('bookThisRoom') }}
						</book-button>
					</span>
					<nuxt-link class="button button-no-fill" :to="localePath('rooms')">
						{{ $t('buttonBackToOverview') }}
					</nuxt-link>
				</div>
			</div>
		</section>
	</page-container>
</template>

<script setup>
import { Fancybox } from '@fancyapps/ui';
import '@fancyapps/ui/dist/fancybox/fancybox.css';

const { page, fetchPage } = usePage();
const localePath = useLocalePath();

onMounted(() => {
	Fancybox.bind('[data-fancybox]', {});
});

await fetchPage();
</script>

<style lang="scss" scoped>
.main-content {
	:deep(ul) {
		padding: 0 0 0 20px;
	}

	:deep(li) {
		width: 50%;
		float: left;
		padding: 0 50px 0 0;
	}
}

.room-icons {
	display: flex;
	flex-wrap: wrap;
	justify-content: flex-start;
	align-items: flex-start;
	margin: 0 0 40px;
}

.gallery-grid {
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	gap: 35px;
	margin-bottom: 25px;
}

.gallery-item {
	cursor: pointer;
}

.icon-holder {
	color: #4a4c35;
	width: 32%;
	margin: 10px 0;

	i,
	svg {
		margin: 0 5px 0 0;
	}
}

.room-item .room-icons {
	max-width: 600px;
}

.room-info {
	padding: 0;
	margin: 75px auto 0;

	.row {
		padding: 50px 30px;

		ul {
			padding-left: 20px;
		}
	}
}

.gallery-section {
	.columns {
		margin: 15px 0;
	}

	.button-no-fill {
		color: var(--cta-color);
		border-color: var(--cta-color);

		&:hover {
			background: var(--cta-color);
			border-color: var(--cta-color);
			color: #fff;
		}
	}
}

.gallery-section img {
	width: 100%;
	height: 100%;
	object-fit: cover;
}

@media (max-width: 920px) {
	.gallery-grid {
		grid-template-columns: repeat(2, 1fr);
	}

	.contentblock-image {
		width: 100%;
		position: relative;
		inset: auto;
	}

	.icon-holder {
		width: 49%;
	}

	.contentblock {
		display: flex;
		flex-flow: wrap column-reverse;
	}

	.contentblock-content {
		margin: 0 auto 50px;
		padding: 50px 30px;
	}

	.room-info .column12 {
		text-align: left;
	}
}

@media (max-width: 680px) {
	.gallery-grid {
		grid-template-columns: 1fr;
	}
}

@media (max-width: 580px) {
	.icon-holder {
		width: 100%;
	}
}
</style>
